/*eslint-disable max-len*/
import React, { Component } from 'react';
import * as MaterialUI from '@material-ui/core';

const { SvgIcon } = MaterialUI;

class ZoomOutIcon extends Component {
	constructor(props) {
		super(props);
		this.props = props;
	}

	render() {
		return (
			<SvgIcon width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...this.props}>
				<g fill="none">
					<path d="M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					<path d="M18 18L20 20" stroke="currentColor" strokeWidth="2" />
					<path d="M23 23L19 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
					<path d="M7 11H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
				</g>
			</SvgIcon>
		);
	}
}

export default ZoomOutIcon;


// WEBPACK FOOTER //
// ./src/components/icons/zoomout.js